module.exports = __webpack_public_path__ + "img/f24.facb5b90.png";